export const formatCurrency = (value: number | undefined) => value?.toLocaleString('en-ZA', { style: 'currency', currency: 'ZAR' });

export function formatDate(dateString: string) {
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return '';
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${d.getUTCDate()} ${months[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}
